import { render, staticRenderFns } from "./DemandDetailsModal.vue?vue&type=template&id=af5086d4&"
import script from "./DemandDetailsModal.vue?vue&type=script&lang=js&"
export * from "./DemandDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DemandDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports